import React from "react";
import { Box, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import StockLogo from "../components/StockLogo";
import { useStockInfo } from "../hooks/useStockInfo";

const formatRecentVisitDate = (dateString) => {
  if (!dateString) return "Unknown";

  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "Just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
};

const HomeRecentStockItem = ({ symbol, lastVisitedAt }) => {
  const { data: stockInfo, loading } = useStockInfo(symbol);
  const companyName = stockInfo?.company_name || symbol;
  const navigate = useNavigate();

  return (
    <Box
      as="button"
      onClick={() => navigate(`/stock/${symbol.toLowerCase()}`)}
      bg="rgba(255, 255, 255, 0.5)"
      _dark={{ bg: "rgba(0, 0, 0, 0.3)" }}
      borderWidth="1px"
      borderRadius="lg"
      p={4}
      textAlign="center"
      w="100%"
      maxW="300px"
      _hover={{
        bg: "rgba(255, 255, 255, 0.7)",
        _dark: { bg: "rgba(0, 0, 0, 0.5)" },
        transform: "translateY(-2px)",
        boxShadow: "md",
      }}
      transition="all 0.2s"
      cursor="pointer"
    >
      <VStack spacing={2}>
        <StockLogo ticker={symbol} companyName={companyName} />
        <Text fontSize="lg" fontWeight="bold">
          {symbol}
        </Text>
        <Text fontSize="sm" color="gray.600" _dark={{ color: "gray.300" }}>
          {loading ? "Loading..." : companyName}
        </Text>
        <Text fontSize="xs" color="gray.500" _dark={{ color: "gray.400" }}>
          Last opened: {formatRecentVisitDate(lastVisitedAt)}
        </Text>
      </VStack>
    </Box>
  );
};

export default HomeRecentStockItem;
